'use strict';

exports.__esModule = true;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = createInject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _utilsShallowEqual = require('../utils/shallowEqual');

var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);

var _utilsIsPlainObject = require('../utils/isPlainObject');

var _utilsIsPlainObject2 = _interopRequireDefault(_utilsIsPlainObject);

var defaultMapProvidedToProps = function defaultMapProvidedToProps(provided) {
  return _extends({}, provided);
};

function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}

function createInject(React) {
  var Component = React.Component;
  var PropTypes = React.PropTypes;

  //@TODO have not tested nextVersion stuff
  var nextVersion = 0;
  return function inject(mapProvidedToProps) {
    var finalMapProvidedToProps = mapProvidedToProps || defaultMapProvidedToProps;

    // Helps track hot reloading.
    var version = nextVersion++;

    function computeProvidedProps(provided) {
      var providedProps = finalMapProvidedToProps(provided);
      _invariant2['default'](_utilsIsPlainObject2['default'](providedProps), '`mapProvidedToProps` must return an object. Instead received %s.', providedProps);
      return providedProps;
    }

    return function wrapWithInject(WrappedComponent) {
      var Inject = (function (_Component) {
        _inherits(Inject, _Component);

        Inject.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState, nextContext) {
          return !_utilsShallowEqual2['default'](this.state.provided, nextState.provided) || !_utilsShallowEqual2['default'](this.props, nextProps);
        };

        _createClass(Inject, null, [{
          key: 'displayName',
          value: 'inject(' + getDisplayName(WrappedComponent) + ')',
          enumerable: true
        }, {
          key: 'WrappedComponent',
          value: WrappedComponent,
          enumerable: true
        }, {
          key: 'contextTypes',
          value: {
            provided: PropTypes.object
          },
          enumerable: true
        }]);

        function Inject(props, context) {
          _classCallCheck(this, Inject);

          _Component.call(this, props, context);
          this.version = version;
          this.provided = context.provided;

          _invariant2['default'](this.provided, 'Could not find "provided" in context ' + ('of "' + this.constructor.displayName + '". ') + 'Wrap a higher component in a <Provider>. ');

          this.state = {
            provided: computeProvidedProps(this.provided)
          };
        }

        Inject.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
          if (!_utilsShallowEqual2['default'](this.provided, nextContext.provided)) {
            this.provided = nextContext.provided;
            this.recomputeProvidedProps(nextContext);
          }
        };

        Inject.prototype.recomputeProvidedProps = function recomputeProvidedProps() {
          var context = arguments.length <= 0 || arguments[0] === undefined ? this.context : arguments[0];

          var nextProvidedProps = computeProvidedProps(context.provided);
          if (!_utilsShallowEqual2['default'](nextProvidedProps, this.state.provided)) {
            this.setState({ provided: nextProvidedProps });
          }
        };

        Inject.prototype.getWrappedInstance = function getWrappedInstance() {
          return this.refs.wrappedInstance;
        };

        Inject.prototype.render = function render() {
          return React.createElement(WrappedComponent, _extends({ ref: 'wrappedInstance'
          }, this.state.provided, this.props));
        };

        return Inject;
      })(Component);

      if (
      // Node-like CommonJS environments (Browserify, Webpack)
      typeof process !== 'undefined' && typeof process.env !== 'undefined' && process.env.NODE_ENV !== 'production' ||
      // React Native
      typeof __DEV__ !== 'undefined' && __DEV__ //eslint-disable-line no-undef
      ) {
          Inject.prototype.componentWillUpdate = function componentWillUpdate() {
            if (this.version === version) {
              return;
            }

            // We are hot reloading!
            this.version = version;

            // Update the state and bindings.
            this.recomputeProvidedProps();
          };
        }

      return Inject;
    };
  };
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-tunnel/lib/components/createInject.js
// module id = 1057
// module chunks = 4